import { render, staticRenderFns } from "./list.vue?vue&type=template&id=2f573612&scoped=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"
import style0 from "./list.vue?vue&type=style&index=0&id=2f573612&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f573612",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f573612')) {
      api.createRecord('2f573612', component.options)
    } else {
      api.reload('2f573612', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=2f573612&scoped=true", function () {
      api.rerender('2f573612', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dealers-users/list.vue"
export default component.exports